import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ChevronRight } from 'lucide-react';

const BreadcrumbContainer = styled.nav`
  padding: var(--spacing-2) 0;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
`;

const BreadcrumbList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  
  &:last-child {
    color: var(--color-text-primary);
  }
`;

const BreadcrumbLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;
  
  &:hover {
    color: var(--color-primary);
  }
`;

const Separator = styled(ChevronRight)`
  margin: 0 var(--spacing-2);
  width: 16px;
  height: 16px;
  color: var(--color-text-secondary);
`;

interface BreadcrumbsProps {
  items?: Array<{
    label: string;
    path: string;
  }>;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  const breadcrumbs = items || pathSegments.map((segment, index) => {
    const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
    const label = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
    return { path, label };
  });

  // Ajout de l'accueil au début
  const allBreadcrumbs = [{ path: '/', label: 'Accueil' }, ...breadcrumbs];

  return (
    <BreadcrumbContainer aria-label="fil d'ariane">
      <BreadcrumbList>
        {allBreadcrumbs.map((crumb, index) => (
          <BreadcrumbItem key={crumb.path}>
            {index < allBreadcrumbs.length - 1 ? (
              <>
                <BreadcrumbLink to={crumb.path}>{crumb.label}</BreadcrumbLink>
                <Separator />
              </>
            ) : (
              <span aria-current="page">{crumb.label}</span>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbContainer>
  );
};
